import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

interface LoadingProps {
    size?: 'full' | 'partial' | 'small';
    type?: 'circular' | 'linear';
}

export function Loading({ size = 'full', type = 'circular' }: LoadingProps) {
    const content = type === 'linear' ? <LinearProgress /> : <CircularProgress size={size === 'small' ? 20 : 40} />;

    if (size === 'small') {
        return content;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: size === 'full' ? '100vh' : '100%',
                minHeight: size === 'partial' ? 200 : undefined,
            }}
        >
            {content}
        </Box>
    );
}
